import { render, staticRenderFns } from "./EmployeesInputSheetAttendanceFloatBtns.vue?vue&type=template&id=2581ea1b&"
import script from "./EmployeesInputSheetAttendanceFloatBtns.vue?vue&type=script&lang=js&"
export * from "./EmployeesInputSheetAttendanceFloatBtns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports